import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  MenuItem,
  Button,
  Tooltip,
  Box,
} from "@mui/material";
import moment from "moment";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import SendIcon from "@mui/icons-material/Send";
import { FindInPage } from "@mui/icons-material";
import PrintIcon from "@mui/icons-material/Print";
import Pagination from "@mui/material/Pagination";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import "moment/locale/es-mx";
import { esES as localeDate } from "@mui/x-date-pickers/locales";
import { RootStoreContext } from "../../app/store/root";
import { account } from "../../shared/Utils";
import { Menu } from "../../app/util/permisos";
import { Acciones } from "../../app/util/permisos";
import { blobToBase64, getOption, validateEmail } from "../../app/util/util";
import { StatusShipment } from "../../app/util/constants";
import { EnumStatusShipment } from "../../shared/Enumerables";

import ModalDetalles from "../../shared/modals/ModalDetalles";
import ModalViewerPdf from "../../shared/modals/ModalViewerPdf";
import { ModalComponent } from "../../app/common/ModalComponent";
import ModalEscaneoGuia from "../../components/usuarios/ModalEscaneoGuia";
import IconShipmentStatus from "../../shared/components/IconShipmentStatus";
import { toJS } from "mobx";

const EnviosUsuariosPage = () => {
  const navigate = useNavigate();
  const rootStore = useContext(RootStoreContext);
  const {
    entities,
    pageSize,
    lastPage,
    currentPage,
    filterUsers,
    entitiesSearched,
    initialUsersFilters,
    getAll,
    getById,
    getExcel,
    onFilter,
    getGuideFile,
    getDataFilters,
    setCurrentPage,
    setFilterUsers,
    clearEntitiesSearched,
  } = rootStore.shipmentStore;
  const { entities: providers, getAll: getAllProviders } =
    rootStore.proveedorStore;

  /* UseSates */
  const [search, setSearch] = useState(undefined);
  const [proveedores, setProveedores] = useState([]);
  const [disableFilter, setDisableFilter] = useState(true);
  const [urlBlob, setUrlBlob] = useState(undefined);
  const [openEscaneo, setOpenDialogEscaneo] = useState(false);
  const [showModalPrint, setShowModalPrint] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [permisosUsuario, setPermisosUsuario] = React.useState([]);
  /* End UseStates */

  useEffect(() => {
    document.title = "Lilofy | Envíos";
    if (
      !account
        .getPermisosUsuario()
        .some((a) => a.clavePermiso == Menu.Envios && a.tienePermiso)
    ) {
      console.log("No tengo permisos para la Envios");
      navigate("/Usuarios/AccessDenied");
    } else {
      setPermisosUsuario(account.getPermisosUsuario());
      getAllProviders();
    }

    return () => {
      setFilterUsers(initialUsersFilters);
    };
  }, []);

  useEffect(() => {
    const data = getDataFilters(filterUsers);
    getAll(data);
  }, [currentPage]);

  useEffect(() => {
    if (providers && providers.length > 0) {
      let newProviders = [...providers];
      newProviders.push({
        id: null,
        proveedores: "Todos",
      });
      setProveedores([...newProviders]);
    }
  }, [providers]);

  useEffect(() => {
    if (
      !filterUsers?.fechaInicio &&
      !filterUsers?.fechaFin &&
      !filterUsers?.idEstatus &&
      !filterUsers?.idProovedor
    )
      setDisableFilter(true);
    else setDisableFilter(false);
  }, [filterUsers]);

  /* Methods */
  const setValueFilter = (key, value) => {
    setFilterUsers({ ...filterUsers, ...{ [key]: value } });
  };

  const handlePaginationChange = (e, p) => {
    setCurrentPage(p - 1);
  };
  const getUrlFile = async (id) => {
    let pdf = await getGuideFile(id);
    const pdfBase64 = await blobToBase64(pdf.data);
    setUrlBlob(pdfBase64);
  };

  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setShowModalDetail(false);
  };

  const handleClosePrintModal = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setShowModalPrint(!showModalPrint);
  };
  /* EndMethods */

  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale="es-mx"
        localeText={
          localeDate.components.MuiLocalizationProvider.defaultProps.localeText
        }
      >
        <div className="main-container">
          <div className="mb-2 d-flex" style={{ alignItems: "center" }}>
            <Box
              sx={{ marginRight: "16px", fontSize: 25 }}
              color="primary.main"
            >
              <SendIcon />
            </Box>
            <Typography color="primary" variant="h4">
              Envíos
            </Typography>
          </div>
          <Card className="card">
            <CardContent>
              {permisosUsuario.some(
                (a) =>
                  a.clavePermiso === Acciones.Recepción_de_guía &&
                  a.tienePermiso
              ) && (
                <Grid
                  container
                  direction={"row"}
                  justifyContent="end"
                  alignItems={"center"}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      onClick={() => setOpenDialogEscaneo(true)}
                    >
                      Recepción de guías
                    </Button>
                  </Grid>
                </Grid>
              )}
              <Grid
                container
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                direction={"row"}
                alignItems={"center"}
              >
                <Grid item xs="12" sm="6" md="2" lg="2">
                  <DatePicker
                    label="Fecha inicio"
                    value={filterUsers?.fechaInicio || null}
                    onChange={(value) => setValueFilter("fechaInicio", value)}
                    renderInput={({ inputRef, inputProps, InputProps }) => (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          label="Fecha inicio"
                          size="small"
                          margin="normal"
                          fullWidth
                          ref={inputRef}
                          {...inputProps}
                        />
                        {InputProps?.endAdornment}
                      </Box>
                    )}
                  />
                </Grid>

                <Grid item xs="12" sm="6" md="2" lg="2">
                  <DatePicker
                    label="Fecha fin"
                    value={filterUsers?.fechaFin || null}
                    onChange={(value) => setValueFilter("fechaFin", value)}
                    renderInput={({ inputRef, inputProps, InputProps }) => (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          label="Fecha fin"
                          size="small"
                          margin="normal"
                          fullWidth
                          ref={inputRef}
                          {...inputProps}
                        />
                        {InputProps?.endAdornment}
                      </Box>
                    )}
                  />
                </Grid>

                <Grid item xs="12" sm="6" md="2" lg="2">
                  {/* <TextField
                    size="small"
                    select
                    fullWidth
                    id="selectProveedores"
                    label="Proveedores"
                    value={filterUsers?.idProovedor || ""}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setValueFilter("idProovedor", e.target.value);
                    }}
                  >
                    {providers.map((x, index) => (
                      <MenuItem key={index} value={x.id}>
                        {x.proveedores}
                      </MenuItem>
                    ))}
                  </TextField> */}
                  <Autocomplete
                    size="small"
                    value={filterUsers?.idProovedor}
                    options={proveedores.map((x) =>
                      getOption(x.proveedores, x.id)
                    )}
                    id="combo-box-proveedores"
                    sx={{ width: "100%" }}
                    onChange={(event, value) => {
                      setValueFilter("idProovedor", value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        margin="normal"
                        size="small"
                        {...params}
                        label="Proveedores"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs="12" sm="6" md="2" lg="2">
                  {/* <TextField
                    size="small"
                    select
                    fullWidth
                    id="selectEstatus"
                    label="Estatus"
                    value={filterUsers?.idEstatus || ""}
                    onChange={(e) =>
                      setValueFilter("idEstatus", e.target.value)
                    }
                  >
                    {StatusShipment.map((x, index) => (
                      <MenuItem key={index} value={Object.entries(x)[0][1]}>
                        {Object.keys(x)[0]}
                      </MenuItem>
                    ))}
                  </TextField> */}
                  <Autocomplete
                    size="small"
                    value={filterUsers?.idEstatus}
                    options={StatusShipment.map((x) =>
                      getOption(
                        Object.keys(x)[0].replace("_", " "),
                        Object.entries(x)[0][1]
                      )
                    )}
                    id="combo-box-estatus"
                    sx={{ width: "100%" }}
                    onChange={(event, value) => {
                      setValueFilter("idEstatus", value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        margin="normal"
                        size="small"
                        {...params}
                        label="Estatus"
                      />
                    )}
                  />
                </Grid>

                <Grid item>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setSearch(undefined);
                      setCurrentPage(0);
                      clearEntitiesSearched();
                      const data = getDataFilters(filterUsers);
                      getAll(data);
                    }}
                    disabled={disableFilter}
                  >
                    Buscar
                  </Button>
                </Grid>

                <Grid item>
                  {permisosUsuario.some(
                    (a) =>
                      a.clavePermiso === Acciones.Exportar_información_envío &&
                      a.tienePermiso
                  ) && (
                    <Button
                      variant="export"
                      onClick={async () => {
                        const data = getDataFilters(filterUsers);
                        await getExcel(
                          data,
                          `Reporte de envíos (${moment(new Date()).format(
                            "DD/MM/YYYY"
                          )}).xlsx`
                        );
                      }}
                    >
                      Exportar a excel
                    </Button>
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                direction={"row"}
                justifyContent="end"
                alignItems={"center"}
                mb={2}
              >
                <Grid item>
                  <TextField
                    size="small"
                    margin="normal"
                    fullWidth
                    id="filter"
                    label="Buscar"
                    name="filter"
                    value={search || ""}
                    onChange={(e) => {
                      onFilter(e.target.value);
                      setSearch(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                {entities.length > 0 ||
                (entitiesSearched && entitiesSearched.length > 0) ? (
                  (entitiesSearched || entities).map((x, index) => (
                    <Grid item xs={12} key={index}>
                      <Card className="card">
                        <CardContent>
                          <Grid
                            container
                            direction={"row"}
                            spacing={2}
                            columns={17}
                            justifyContent="space-between"
                          >
                            <Grid
                              sm={2}
                              item
                              direction={"column"}
                              alignItems="center"
                              justifyContent={"center"}
                              display={"flex"}
                            >
                              <IconShipmentStatus idStatus={x.idEstatus} />
                              <Typography
                                variant="subtitle"
                                mt={2}
                                className="text-center"
                              >
                                {x.fechaEstatus
                                  ? moment(new Date(x.fechaEstatus)).format(
                                      "DD/MM/YYYY"
                                    )
                                  : ""}
                              </Typography>
                            </Grid>

                            <Grid
                              item
                              sm={13}
                              display={"flex"}
                              alignItems="center"
                            >
                              <Grid
                                container
                                direction={"row"}
                                spacing={2}
                                columns={14}
                              >
                                <Grid
                                  sm={4}
                                  md={2}
                                  lg={2}
                                  item
                                  direction={"column"}
                                  display={"flex"}
                                >
                                  <Typography variant="h6">
                                    No. de guía
                                  </Typography>
                                  <Typography variant="subtitle" mt={2}>
                                    {`#${x.numeroGuia}`}
                                  </Typography>
                                </Grid>

                                {x.idEstatus !== EnumStatusShipment.Creado &&
                                  x.idEstatus !==
                                    EnumStatusShipment.Recibido && (
                                    <Grid
                                      sm={4}
                                      md={3}
                                      lg={3}
                                      item
                                      direction={"column"}
                                      display={"flex"}
                                    >
                                      <Typography variant="h6">
                                        No. de carta porte
                                      </Typography>
                                      <Typography variant="subtitle" mt={2}>
                                        {x.numeroCartaPorte}
                                      </Typography>
                                    </Grid>
                                  )}

                                <Grid
                                  sm={6}
                                  md={3}
                                  lg={3}
                                  item
                                  direction={"column"}
                                  display={"flex"}
                                >
                                  <Typography variant="h6">
                                    Detalles del envío
                                  </Typography>
                                  <Typography variant="subtitle" mt={2}>
                                    {x.descripcionEnvio}
                                  </Typography>
                                </Grid>

                                <Grid
                                  item
                                  sm={4}
                                  md={3}
                                  lg={3}
                                  direction={"column"}
                                  display={"flex"}
                                >
                                  <Typography variant="h6">Destino:</Typography>
                                  <Typography variant="subtitle" mt={2}>
                                    {x.destino}
                                  </Typography>
                                </Grid>

                                <Grid
                                  sm={4}
                                  md={3}
                                  lg={3}
                                  item
                                  direction={"column"}
                                  display={"flex"}
                                >
                                  <Typography variant="h6">
                                    Fecha estimada de llegada
                                  </Typography>
                                  <Typography variant="subtitle" mt={2}>
                                    {x.fechaEstimadaLlegada
                                      ? moment(
                                          new Date(x.fechaEstimadaLlegada)
                                        ).format("DD/MM/YYYY")
                                      : ""}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid
                              sm={1}
                              item
                              container
                              direction={"column"}
                              display={"flex"}
                              justifyContent={"center"}
                            >
                              {permisosUsuario.some(
                                (a) =>
                                  a.clavePermiso === Acciones.Imprimir_envíos &&
                                  a.tienePermiso
                              ) && (
                                <Tooltip title="Imprimir guía" placement="top">
                                  <PrintIcon
                                    fontSize="large"
                                    onClick={async () => {
                                      await getUrlFile(x.idGuia);
                                      setShowModalPrint(true);
                                    }}
                                    sx={{ marginBottom: "10px" }}
                                  />
                                </Tooltip>
                              )}
                              {permisosUsuario.some(
                                (a) =>
                                  a.clavePermiso ===
                                    Acciones.Ver_detalle_envío && a.tienePermiso
                              ) && (
                                <Tooltip title="Ver detalle" placement="top">
                                  <FindInPage
                                    fontSize="large"
                                    onClick={() => {
                                      getById(x.idGuia);
                                      setShowModalDetail(true);
                                    }}
                                    sx={{ marginBottom: "10px" }}
                                  />
                                </Tooltip>
                              )}
                              {permisosUsuario.some(
                                (a) =>
                                  a.clavePermiso === Acciones.Editar_guía &&
                                  a.tienePermiso
                              ) && (
                                <Tooltip title="Editar" placement="top">
                                  <EditIcon
                                    fontSize="large"
                                    sx={{ marginBottom: "10px" }}
                                    onClick={() => {}}
                                  />
                                </Tooltip>
                              )}
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h6" style={{ margin: "auto" }} mt={2}>
                      No se encontraron resultados
                    </Typography>
                  </div>
                )}
              </Grid>
              <Pagination
                count={lastPage}
                page={currentPage + 1}
                onChange={handlePaginationChange}
              />
            </CardContent>
          </Card>
        </div>
      </LocalizationProvider>

      <ModalEscaneoGuia
        open={openEscaneo}
        onClose={() => setOpenDialogEscaneo(!openEscaneo)}
      />
      <ModalComponent
        Open={showModalDetail}
        HandleClose={handleClose}
        ClassName="modal-xl"
        Body={() => <ModalDetalles onClose={handleClose} />}
      />
      <ModalComponent
        Open={showModalPrint}
        HandleClose={handleClosePrintModal}
        ClassName="modal-xl"
        Body={() => (
          <ModalViewerPdf urlBlob={urlBlob} onClose={handleClosePrintModal} />
        )}
      />
    </>
  );
};

export default observer(EnviosUsuariosPage);
